/**
 * Created by guyavarham on 10/05/2017.
 */

// todo: bring from common proj
export default { indices: false, encode: true, allowDots: true, skipNulls: true };
